module.exports = __webpack_public_path__ + "static/media/o7876867.87892249.png";